// Candy-Crush-style combo praise (§5). Chaining discoveries within a 5s window
// escalates the praise word + multiplier; high-tier finds get special words.
export interface Praise {
  word: string;
  mult: number;
  color: string;
  seq: number;
}

const WORDS: Record<number, string> = {
  1: "Nice!",
  2: "Sweet!",
  3: "Delicious!",
  4: "Wonderful!",
  5: "Spectacular!",
  6: "Unstoppable!",
};
const COLORS = ["#65A30D", "#60A5FA", "#34D399", "#F5B740", "#F472B6", "#FB7185"];

export const makePraise = (combo: number, tier: number, seq: number): Praise => {
  let word = WORDS[Math.min(combo, 6)] || "LEGENDARY!";
  let color = COLORS[Math.min(combo - 1, COLORS.length - 1)];
  if (tier >= 7) {
    word = "MYTHIC!";
    color = "#FBBF24";
  } else if (tier >= 6 && combo < 4) {
    word = "Legendary find!";
    color = "#FB923C";
  } else if (tier >= 5 && combo < 3) {
    word = "Epic!";
    color = "#F472B6";
  }
  return { word, mult: combo, color, seq };
};
